<template>
  <div class="activationResult pointer">
    <NavBar title="激活结果" />
    <div class="main">
      <div class="condition">
        成功{{ activationCodeList.successNum }}台，失败{{
          activationCodeList.failNum
        }}台
      </div>
      <div class="conditionListBox">
        <div
          class="conditionList"
          v-for="(item, index) in activationCodeList.useActivationCodes"
          :key="index"
        >
          <div>
            <p class="p1">{{ item.instancesName }}</p>
            <p class="p2">{{ item.activationCode }}</p>
          </div>
          <div>
            <span v-if="item.activateStatus == 0" class="isssucc"
              >激活码成功</span
            >
            <span v-if="item.activateStatus == 1" class="issspan"
              >激活码已过期</span
            >
            <span v-if="item.activateStatus == 2" class="issshiyong"
              >激活码已使用</span
            >
            <span v-if="item.activateStatus == 3" class="isscuowu"
              >激活码不存在</span
            ><span v-if="item.activateStatus == 4" class="isscuowu"
              >设备分配异常</span
            >
            <span v-if="item.activateStatus == 5" class="isscuowu"
              >设备型号和激活码型号不一致</span
            >
            <span v-if="item.activateStatus == 6" class="isscuowu"
              >该类型限一次</span
            >
            <span v-if="item.activateStatus == 7" class="isscuowu"
              >库存紧张,暂时无法新增</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="baseBox" v-if="activationCodeList.failNum > 1">
      <button class="btn" @click="wancheng">一键复制使用失败的激活码</button>
    </div>
  </div>
</template>
  
  <script>
import NavBar from "@/components/NavBar.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "ActivationResult",
  components: {
    NavBar,
  },
  data() {
    return {};
  },

  mounted() {},
  beforeDestroy() {
    this.SET_ACTIVATIONCODELIST([]);
  },
  computed: {
    ...mapState("persistence", ["activationCodeList"]),
  },

  methods: {
    ...mapMutations("persistence", ["SET_ACTIVATIONCODELIST"]),
    wancheng() {
      let value = this.activationCodeList.useActivationCodes
        .map((item) => item.activationCode)
        .join("\n");
      this.$common.moreCopy(value, "复制成功!");
    },
  },
};
</script>
  
  <style lang="less" scoped>
.activationResult {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  padding: 10px 16px;
  .condition {
    text-align: left;
    font-size: 16px;
    font-weight: 700;
  }
  .conditionListBox {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    touch-action: manipulation;
    scrollbar-width: none;
    .conditionList {
      display: flex;
      background: #fff;
      align-items: center;
      justify-content: space-between;
      padding: 12px;
      border-radius: 6px;
      margin-top: 12px;
      text-align: left;
      .p1 {
        margin-bottom: 5px;
      }
      .issspan {
        color: #666666;
      }
      .isssucc {
        color: #26bd5f;
      }
      .issshiyong {
        color: #ffb800;
      }
      .isscuowu {
        color: #ff3e24;
      }
      .isswei {
        color: #333333;
      }
    }
  }
}
.baseBox {
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -1px 8px 0 hsla(0, 0%, 39%, 0.2);
  color: #333;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 0;
  .btn {
    width: 90%;
    height: 44px;
    border: none;
    background: #886df3;
    border-radius: 44px;
    font-size: 16px;
    color: #f6f8fb;
    line-height: 23px;
    letter-spacing: 0px;
    text-align: center;
  }
}
</style>